import { render, staticRenderFns } from "./debugParams.vue?vue&type=template&id=64d5e5e2&scoped=true"
import script from "./debugParams.vue?vue&type=script&lang=js"
export * from "./debugParams.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d5e5e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64d5e5e2')) {
      api.createRecord('64d5e5e2', component.options)
    } else {
      api.reload('64d5e5e2', component.options)
    }
    module.hot.accept("./debugParams.vue?vue&type=template&id=64d5e5e2&scoped=true", function () {
      api.rerender('64d5e5e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/debugParams.vue"
export default component.exports